import {Route} from 'vue-router';

const OBJECT_ID = /^[0-9a-f]{24}$/i;

/** Id of the entry to show from `?log=<id>` (e.g. opened from a mention notification) */
export function getFocusLogId(route: Route | undefined): string | null {
    const value = route?.query?.log;
    const id = Array.isArray(value) ? value[0] : value;
    return typeof id === 'string' && OBJECT_ID.test(id) ? id : null;
}

/** Scrolls to an entry card (cards have the log id as element id) once it is rendered */
export function scrollToEntryWhenRendered(id: string, attempts = 20): void {
    const element = document.getElementById(id);
    if (element) {
        element.scrollIntoView({behavior: 'smooth', block: 'center'});
        return;
    }
    if (attempts > 0) {
        window.setTimeout(() => scrollToEntryWhenRendered(id, attempts - 1), 150);
    }
}
